// Dock height constants
export const CLUB_DOCK_HEIGHT = 84;
export const ASK_DOCK_HEIGHT = 72;
export const DOCK_HEIGHT = 100;
export const DOCK_HEIGHT_TABLET = 135; // Height on tablet expanded (768-1100px)
export const DOCK_HEIGHT_MOBILE = 165; // Height on mobile expanded (<768px)
export const LEGACY_BAR_HEIGHT = 64;
export const DOCK_MINIMIZED_HEIGHT = 44; // Height when dock is collapsed
export const TABLET_BREAKPOINT = 1100; // Width at which dock becomes collapsible
